export default "__VITE_ASSET__DuIDnPCd__"